export const UPDATE_SEARCHLIST = 'interviewsSearch/updateResults'
export const RESET_FILTERS = 'interviewsSearch/reset'
export const RESET_RESULTS = 'interviewsSearch/resetTableData'
export const UPDATE_CONTROL_NO = 'interviewsAdd/getControlNo'
export const GET_DETAIL = 'interviews/getDetails'
export const SET_CONFIRM_MODAL = 'interviewsSearch/setConfirmModal'
export const HIDE_CONFIRM_MODAL = 'interviewsSearch/hideConfirmModal'
export const SHOW_CONFIRM_MODAL = 'interviewsSearch/showConfirmModal'

// SEARCH FILTER TYPES
export const APPLY_FILTERS = 'interviewsSearch/applySearchFilter'
export const CHG_FILTER_DATA = 'interviewsSearch/changeFilterField'
export const CHG_FILTER_PAGE = 'interviewsSearch/changePage'
export const CHG_FILTER_PAGE_SIZE = 'interviewsSearch/changePageSize'
export const CHG_FILTER_SORT = 'interviewsSearch/changeSortModel'
export const IS_LOADING = 'interviewsSearch/isLoading'
export const CHG_SELECTED_ROWS = 'interviewsSearch/changeSelected'
export const HIDE_LIST_ALERT = 'interviewsSearch/hideAlert'
export const SET_LIST_ALERT = 'interviewsSearch/setAlertModal'

// ADD FORM TYPES
export const CHG_FIELD = 'interviewsAdd/changeField'
export const CHG_STATUS = 'interviewsAdd/changeStatus'
export const CHG_EMPLOYEE_ID = 'interviewsAdd/changeEmployeeId'
export const CHG_INCOME_ID = 'interviewsAdd/changeIncomeId'
export const CHG_AMOUNT = 'interviewsAdd/changeAmount'
export const CHG_EFFECTIVE_DATE = 'interviewsAdd/changeEffectiveData'
export const CHG_MEMO = 'interviewsAdd/changememo'
export const RESET_ADD_DATA = 'interviewsAdd/reset'
export const UPD_ADD_ALERT = 'interviewsAdd/updateAlert'
export const HIDE_ADD_ALERT = 'interviewsAdd/hideAlert'
export const UPD_ADD_MEMO_CHAR_COUNT = 'interviewsAdd/updateMemoCharCount'
export const INSERT_LOADING = 'interviewsAdd/isLoading'
export const SET_ADD_DATA = 'interviewsAdd/setAddData'
export const SET_HOLIDAY_DATES = 'interviewsAdd/setHolidayDates'


// DETAIL FORM TYPES
export const UPD_DETAIL_TITLE = 'interviewsDetail/changeTitle'
export const RESET_DETAIL_DATA = 'interviewsDetail/reset'
export const CHG_DETAIL_DATA = 'interviewsDetail/changeFieldData'
export const UPD_DETAIL_MODE = 'interviewsDetail/changeMode'
export const HAS_DETAIL_LOADED = 'interviewsDetail/hasDetailLoaded'
export const SET_DETAIL_DATA = 'interviewsDetail/setDetailData'
export const UPD_AMOUNT = 'interviewsDetail/changeAmount'
export const UPD_DETAIL_MEMO_CHAR_COUNT = 'interviewsDetail/updateMemoCharCount'
export const UPD_DETAIL_DATA = 'interviewsDetail/updateDetailData'
export const SET_DETAIL_CONFIRM_MODAL = 'interviewsDetail/setConfirmModal'
export const HIDE_DETAIL_CONFIRM_MODAL = 'interviewsDetail/hideConfirmModal'
export const SHOW_DETAIL_CONFIRM_MODAL = 'interviewsDetail/showConfirmModal'
export const SET_DETAIL_ALERT = 'interviewsDetail/setAlertModal'
export const HIDE_DETAIL_ALERT = 'interviewsDetail/hideAlert'


